module.exports = __webpack_public_path__ + "img/ic_16_questions.f0899e9e.svg";